<div class="selected-tag-box">
  <div class="selected-tag-box__title">Top Error Templates</div>
  <mat-card class="selected-tag-box__card top-errors-card">
    <div class="top-error-container">
      <sh-errors-widget
        [queryModel]="logQueryModel"
        [theme]="'light'"
        [enableLoading]="true"
        (viewState)="changeReadyState($event)"
        [addInvertedClassToLoader]="true">
      </sh-errors-widget>
      <div *ngIf="viewState$ === completedViewState" class="template-button-wrapper">
        <cgx-button
          label="VIEW ALL ERROR TEMPLATES"
          size="md"
          textNoWrap
          [outline]="true"
          (press)="redirectToLogsPage()"
        ></cgx-button>
      </div>
    </div>
  </mat-card>
</div>
